import {put,takeLatest,call} from 'redux-saga/effects';
import * as imageService from "../../../services/imageService";
import {
    GET_COMMON_IMAGES,
    GET_COMMON_IMAGES_SUCCESS,
    GET_COMMON_IMAGES_ERROR
}
    from "../../actions/image";

function* getCommonImagesSaga(action) {
    try {
        const data=yield call(imageService.GetCommonImages,action.payload)
        yield put({
            type: GET_COMMON_IMAGES_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_COMMON_IMAGES_ERROR,error: error.data
        });
    }
}

export function* getCommonImagesSagaWatcher() {
    yield takeLatest(GET_COMMON_IMAGES,getCommonImagesSaga);
}